// import type {SwiperOptions} from '../../../libs/node_modules/swiper/types/swiper-options';


export class cAdCarousel {
  constructor () {

    const count     = document.querySelectorAll('.c-ad-carousel .swiper-slide').length;
    const container = document.querySelector('.c-ad-carousel') as HTMLElement;

    let breakpoints: any = {};
    if (count === 2) {
      breakpoints = {
        640: {
          slidesPerView : 2,
          spaceBetween  : 8,
        },
      };

    }
    if (count >= 3) {
      breakpoints = {
        640: {
          slidesPerView : 2,
          spaceBetween  : 8,
        },
        1460: {
          slidesPerView : 3,
          spaceBetween  : 8,
        },
      };
    }


    const swiper = new Swiper('.c-ad-carousel .swiper', {
      slidesPerView : 1,
      spaceBetween  : 8,
      speed         : 400,
      loop          : true,
      freeMode      : true,
      grabCursor    : true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: true,
      },
      breakpoints: breakpoints,
      pagination: {
        el: ".c-ad-carousel .swiper-pagination",
        clickable: true,
      },
    });

    container.style.opacity = "1";

  }
}